import React from 'react';
import I18n from 'i18n-js';
import PropTypes from 'prop-types';
import InputField from 'components/v2/input-field/input-field';

const localeKeyPrefix = 'shopify.settings.basicSettingsSection.form';

const ItemWeightField = props => {
  const { initialValue, ...other } = props;
  return (
    <InputField
      {...other}
      placeholder={`${I18n.t(`${localeKeyPrefix}.placeholder.itemWeight`)}`}
      type="text"
      suffix="kg"
      fieldOptions={{
        initialValue: initialValue === 0 ? '' : initialValue,
        rules: [
          {
            type: 'number',
            transform: x => {
              const value = Number(x);
              return isNaN(value) ? Number(value) : value;
            },
            validator: (_, value, callback) => {
              if (isNaN(value)) {
                callback(
                  `${I18n.t(
                    `${localeKeyPrefix}.validation.itemWeightNotNumber`,
                  )}`,
                );
                return;
              }
              value && value < 0.01
                ? callback(
                    `${I18n.t(`${localeKeyPrefix}.validation.itemWeightMin`)}`,
                  )
                : callback();
            },
          },
        ],
      }}
    />
  );
};

ItemWeightField.propTypes = {
  id: PropTypes.string.isRequired,
  form: PropTypes.shape({}).isRequired,
  initialValue: PropTypes.string,
  disabled: PropTypes.bool,
};

ItemWeightField.defaultProps = {
  initialValue: '',
  disabled: false,
};

export default ItemWeightField;
